import React from 'react';

import routes from 'core/routes';

import SecureRoute from '../SecureRoute';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => (
  <SecureRoute isAuthorized={(session) => session.isAuthenticated} redirectTo={routes.login}>
    {children}
  </SecureRoute>
);

export default PrivateRoute;
